import BaseStyle from '@primevue/core/base/style';

var ColumnGroupStyle = BaseStyle.extend({
  name: 'columngroup'
});

export { ColumnGroupStyle as default };
//# sourceMappingURL=index.mjs.map
